var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandAll = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-icon",
  style: {
    width: "1em",
    height: "1em",
    verticalAlign: "middle",
    fill: "currentColor",
    overflow: "hidden"
  },
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M305.066667 344.32a21.333333 21.333333 0 0 1 0-30.293333l176.213333-176.64a32 32 0 0 1 22.613333-9.386667h16.213334a32.853333 32.853333 0 0 1 22.613333 9.386667l176.213333 176.64a21.333333 21.333333 0 0 1 0 30.293333l-30.293333 30.293333a20.906667 20.906667 0 0 1-29.866667 0L512 227.413333 365.226667 374.613333a21.333333 21.333333 0 0 1-30.293334 0z m384 305.066667a21.333333 21.333333 0 0 0-30.293334 0L512 796.586667l-146.773333-146.773334a20.906667 20.906667 0 0 0-29.866667 0l-30.293333 30.293334a21.333333 21.333333 0 0 0 0 30.293333l176.213333 176.64a32.853333 32.853333 0 0 0 22.613333 9.386667h16.213334a32 32 0 0 0 22.613333-9.386667l176.213333-176.64a21.333333 21.333333 0 0 0 0-30.293333z"
})));
export default SvgExpandAll;